import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  getFormData,
  getFormUploads,
  updateFormField,
} from 'store/forms/actions';
import { TabsTimeline, FormFooter } from 'components';
import { isNil } from 'lodash';
import { checkUser, checkUserLogged, getUser , getTaxisData} from 'store/user/actions';
import { checkUniqueness } from 'store/forms/actions';
import { getMainformDetails, kadBranchesService } from 'store/forms/actions';
import { stepsSupplier } from './stepsSupplier';
import { useNavigate } from 'react-router-dom';
import { isBeneficiary, handleCheckUniqueness } from '../../../utils';

import isEmpty from 'lodash/isEmpty';
import { Spin } from 'antd';
import { useSupplierType } from 'hooks/useSupplierType';

const MainFormsSupplier = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [current, setCurrent] = useState(0);
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab);
  // const [requiredFieldsError, setRequiredFieldsError] = useState(true);
  const user = useSelector(state => state.user);
  const task = useSelector(state => state.forms.task);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const auditorComment = useSelector(state => state.forms?.auditor?.auditorComment);
  const objectionCommitteeComment = useSelector(state => state.forms?.objection?.objectionCommitteeComment);
  const objCommentBen = useSelector(state => state.forms.carrier.objCommentBen);
  const loadingPage = useSelector(state=>state.user.loading);
  const [loadingPageVar, setLoadingPageVar] = useState(true);
  const { isDirectSupplier, isIndirectSupplier } = useSupplierType()
  const currentDate = new Date().toISOString().split('T')[0];
  const activeTaskName = useSelector(state => state.forms.activeTaskName);

  useEffect(() => {
    dispatch(getUser());
    dispatch(getTaxisData());
    dispatch(getFormData(params.taskId));
    dispatch(getFormUploads(params.taskId));
    if(window.location.pathname.includes('view')){
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'viewMode',
          value: true
           
        })
      );
    }
  }, [dispatch, params.taskId]);

    useEffect(() => {
    if(viewMode || (( activeTaskName && activeTaskName !== "task.name.submit_application"))){
      if(!isEmpty(task?.processInstanceId)){
        dispatch(getMainformDetails(task?.processInstanceId));
      }
    }
    }, [task?.processInstanceId, activeTaskName]);

  useEffect(()=>{
    if(!isNil(loadingPage)){
      setLoadingPageVar(loadingPage);
    }
  },[loadingPage]);

  useEffect(() => {
    dispatch(
      checkUserLogged(
        navigate,
        callback => {
          if(callback){
            dispatch(getUser());
          }
        }
      ),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
        dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(()=> {
    if(!viewMode && 
        (
          isBeneficiary(user?.groups) &&
          !isNil(user?.taxis_data?.afm) &&
          activeTaskName === "task.name.submit_application"
        )
    ){
        dispatch(kadBranchesService(user?.taxis_data?.afm, currentDate));
    }
  },[dispatch, user?.taxis_data, activeTaskName])

  useEffect(() => {
    if (user?.taxis_data?.afm) {
      handleCheckUniqueness({
        user,
        dispatch,
        checkUniqueness,
      }).then(res => {
        dispatch(
          updateFormField({
            group: 'checkUniquenessCreate',
            key: 'canCreate',
            value: res.acceptable,
          })
        );
        dispatch(
          updateFormField({
            group: 'checkUniquenessCreate',
            key: 'acceptableDate',
            value: res.acceptableDate,
          })
        );
        dispatch(
          updateFormField({
            group: 'checkUniquenessCreate',
            key: 'acceptableEquipmentUpdate',
            value: res.acceptableEquipmentUpdate,
          })
        );
      });
      
      dispatch(kadBranchesService(user?.taxis_data?.afm, currentDate));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.taxis_data?.afm]);

  // Set current step based on user and Status
  useEffect(() => {
    if (!stepsSupplier) return;

    if (isBeneficiary(user?.groups)) {
      if (activeTaskName === 'task.name.temporary_rejected') {
        if (isIndirectSupplier && isDirectSupplier) setCurrent(7); // Άμεσος και Έμμεσος
        else if(isIndirectSupplier && !isDirectSupplier) setCurrent(4); // Έμμεσος
        else if(!isIndirectSupplier && isDirectSupplier) setCurrent(6); // Άμεσος
        else setCurrent(0);
      } 
    } else if(activeTaskName === 'task.name.accepted') {
         setCurrent(0);
    }  else {
      setCurrent(0);
    }
  }, [activeTaskName, user?.groups, isDirectSupplier, isIndirectSupplier, stepsSupplier]);


  return (
    loadingPageVar ?
    <div
      style={{
        position:"absolute",
        left:"50%",
        top:"50%"
      }}
    >
      <Spin size="large" />
    </div> 
    :
    <div id="mainforms-page-1" className="investor-form-container">

     {!isNil(current) && 
     <div className="investor-steps-footer-container">
      <TabsTimeline 
          tabs={stepsSupplier({ isDirectSupplier, isIndirectSupplier, activeTaskName, auditorComment, objCommentBen, objectionCommitteeComment })}
          current={current} 
          setCurrent={setCurrent} 
          customClass={`custom-tabs-timeline active-tab-${current+1}`}
      />
      <FormFooter 
          tabs={stepsSupplier({ isDirectSupplier, isIndirectSupplier, activeTaskName, auditorComment, objCommentBen, objectionCommitteeComment })}
          current={current} 
          setCurrent={setCurrent} 
          currentSubTab={currentSubTab} />
      </div>
      }
    </div>
  );
};

export default MainFormsSupplier;
